import { render } from "./NotePage.vue?vue&type=template&id=14b3206a&scoped=true"
import script from "./NotePage.vue?vue&type=script&lang=js"
export * from "./NotePage.vue?vue&type=script&lang=js"

import "./NotePage.vue?vue&type=style&index=0&id=14b3206a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14b3206a"]])

export default __exports__